
import request   from '../Functions/ajax/request'


export default function CategoryLoader ({ params })
{
	return { page: getNews(true, params), params };
}

async function getNews (retry=true, params)
{

	const CATEGORIE = params.categorie;

	try
	{
		var response = await request('/news/list-by-category')
		.config({ })
		.post({ categorie: CATEGORIE });
	}
	catch (update)
	{
		if (['DENIED', 'FORBIDDEN'].includes(update.ERROR_CODE))
		{
			throw { code: 401, throw_up: true };
		}

		if (update.ERROR_CODE) throw update;

		if (!retry) throw update;
	}

	return { categorie: CATEGORIE, articles: response.data };
}